export default __webpack_public_path__ + "static/media/PhilAntiporda_Resume.ea1e522f.pdf";